import React from "react";
import ShiftWeekCalendar from "./ShiftWeekCalendar";
import "../../starek.css";

function ShiftsCalendarView({
    items,
    selectedRows,
    onSelectedRowsChange,
    filterText,
    onEventClick,
}) {
    return <ShiftWeekCalendar shifts={items} onEventClick={onEventClick} />;
}

export default ShiftsCalendarView;
